<template>
  <div v-if="infos.page">
    <v-layout row class="my-5">
      <v-flex xs12 sm8 offset-sm2 lg8 offset-lg2>
        <v-card flat color="xtransparent" class="elevation-24"
        v-if="infos.page.Blogeintrag">
          <v-card-title primary-title class="grey lighten-4 px-4">
            <h3 class="display-1 mb-0">{{ infos.title }}</h3>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="subheading px-4" v-if="infos.page.content">
            <div v-html="infos.page.content"></div>
          </v-card-text>
        </v-card>

        <v-card flat color="xtransparent" class="elevation-4"
        v-else>
          <v-card-title primary-title class="grey lighten-4 px-4">
            <h3 class="display-1 mb-0">{{ infos.title }}</h3>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="subheading px-4" v-if="infos.page.content">
            <div v-html="infos.page.content"></div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- {{ infos }} -->
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      infos: {
        title: '',
        address: '',
        content: '',
        email: '',
        page: ''
      }

    }
  },
  beforeRouteEnter (to, from, next) {
    axios
      .get('/api/v1/infos/' + to.params.id)
      .then(resp => {
        next(vm => (vm.infos = resp.data))
      })
      .catch(error => {
        if (error.response) {
          console.log('err response')
          console.log(error.response.data)
          console.log(error.response.status)
          console.log(error.response.headers)
        } else if (error.request) {
          console.log('request putt')
          console.log(error.request)
        } else {
          console.log('Error', error.message)
        }

        //  app.$router.push('/')
        next('/404')
      })
  },
  beforeRouteUpdate (to, from, next) {
    // this.anzeige.anzeige = null
    //   const app = this
   // let id = app.$route.params.id;
    axios
      .get('/api/v1/infos/' + to.params.id)
      .then(resp => {
        this.setData(resp.data)
        // app.anzeige = resp.data
        next()
        // next(vm => (vm.anzeige = resp.data))
      })
      .catch(error => {
        if (error.response) {
          console.log('err response')
          console.log(error.response.data)
          console.log(error.response.status)
          console.log(error.response.headers)
        } else if (error.request) {
          // console.log('request putt')
          //   console.log(error.request);
        } else {
          console.log('Error', error.message)
        }

        //  app.$router.push('/')
        next('/404')
      })
  },

  created () {

  },
  watch: {
    // call again the method if the route changes
    // '$route': 'fetchData'
  },
  methods: {
    setData (data) {
      this.infos = data
    },

    disableTracking () {
      this.$ga.disable()
    },
    enableTracking () {
      this.$ga.enable()
    }
  },
  metaInfo () {
    return { title: this.infos.title }
  }
}
</script>